import React, { Dispatch, FC, useEffect, useState } from 'react';

// Styles
import './sidebar.scss';

// Components
import { SidebarMenu } from '../sidebar-menu/sidebar-menu';
import { SidebarHeader } from '../sidebar-header/sidebar-header';
import { ExpertList } from '../../../../shared/ui-components/expert';

// Models
import { ICoreState } from '../../../../store/core/core.slice';
import { TExpertsList } from '../../../../store/experts/experts.slice';
import { ISidebarState } from '../../../../store/sidebar/sidebar.slice';

interface ISidebarProps {
  sidebarOpened: boolean;
  hideSidebarActionBtn: boolean;
  setSidebarOpened: Dispatch<boolean>;
  sidebarState: ISidebarState;
  coreState?: ICoreState;
}

export const Sidebar: FC<ISidebarProps> = (
  { coreState, sidebarOpened, hideSidebarActionBtn, sidebarState, setSidebarOpened }: ISidebarProps
): JSX.Element => {
  const [type, setType] = useState<TExpertsList | null>(null);
  const currentPath = coreState?.path.current ?? '';

  const toggleSidebar = (): void => {
    setSidebarOpened(!sidebarOpened);
  }

  useEffect(() => {
    if (sidebarState.type === 'history') {
      setType('history');
      return;
    }
    if (sidebarState.type === 'home' || sidebarState.type === 'business-information') {
      setType('all');
      return;
    }
    if (sidebarState.type === 'favorites') {
      setType('favorites');
      return;
    }
  }, [sidebarState.type]);

  return (
    <aside className={ "sidebar" + (sidebarOpened ? '' : ' close-sidebar') }>
      <SidebarHeader sidebarOpened={ sidebarOpened } hideSidebarActionBtn={ hideSidebarActionBtn }
                     toggleSidebar={ toggleSidebar }/>
      <div className="sidebar-body">
        { !!type &&
          <ExpertList hidden={ !sidebarOpened } type={ type } navSuffix={ type === 'history' ? 'history' : '' }/> }
      </div>
      <div className="sidebar-footer">
        <SidebarMenu sidebarState={ sidebarState } sidebarOpened={ sidebarOpened } currentPath={ currentPath }/>
      </div>
    </aside>
  )
};
